import { useRef, useState } from "react";

interface Props {
  accept: string;
  multiple?: boolean;
  fileTypeLabel: string;
  title: string;
  subtitle: string;
  buttonLabel: string;
  onFiles: (files: FileList) => void;
}

export function UploadDropzone({ accept, multiple, fileTypeLabel, title, subtitle, buttonLabel, onFiles }: Props) {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <div
      className={`flex flex-col items-center justify-center gap-3.5 rounded-lg border-[1.5px] border-dashed px-5 py-7.5 text-center ${
        isDragging ? "border-rs-green bg-rs-green/10" : "border-[#3c4235] bg-rs-black"
      }`}
      onDragEnter={(event) => {
        event.preventDefault();
        setIsDragging(true);
      }}
      onDragOver={(event) => {
        event.preventDefault();
        setIsDragging(true);
      }}
      onDragLeave={(event) => {
        event.preventDefault();
        setIsDragging(false);
      }}
      onDrop={(event) => {
        event.preventDefault();
        setIsDragging(false);
        if (event.dataTransfer.files.length) onFiles(event.dataTransfer.files);
      }}
    >
      <svg className="w-11 h-13 flex-none text-rs-green" viewBox="0 0 44 52" aria-hidden="true">
        <path
          d="M4 2h24l12 12v34a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        />
        <path d="M28 2v12h12" fill="none" stroke="currentColor" strokeWidth="2" />
        <text x="22" y="38" textAnchor="middle" fontSize="10" fontWeight="700" fill="currentColor">
          {fileTypeLabel}
        </text>
      </svg>
      <div>
        <b className="block mb-1 text-[15px] font-bold text-white">{title}</b>
        <span className="text-[13px] text-[#a9b0a1]">{subtitle}</span>
      </div>
      <button
        type="button"
        className="inline-flex items-center gap-2 rounded-md border border-[#3c4235] bg-transparent px-4 py-2.5 text-sm font-medium text-rs-off-white hover:border-rs-green hover:text-rs-green"
        onClick={() => fileInputRef.current?.click()}
      >
        {buttonLabel}
      </button>
      <input
        ref={fileInputRef}
        type="file"
        className="hidden"
        accept={accept}
        multiple={multiple}
        onChange={(event) => {
          if (event.target.files?.length) onFiles(event.target.files);
          event.target.value = "";
        }}
      />
    </div>
  );
}
